module.exports = __webpack_public_path__ + "assets/img/ac92619680c0ee9603221f7de6e20efd.png";